import React from 'react';
import { EntityFilter } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';
import { isTeamGroup } from './teamDisplayName';

/**
 * 自定义过滤器：只显示符合条件的 team group
 * - 以 -owners 结尾
 * - 以 -viewers 结尾
 * - system-manager
 */
export class TeamsNameFilter implements EntityFilter {
  filterEntity(entity: Entity): boolean {
    // 只处理 group 类型的实体
    if (entity.kind !== 'Group') {
      return false;
    }

    const groupName = entity.metadata.name;
    return isTeamGroup(groupName);
  }
}

/**
 * TeamsNameFilter 的 UI 组件
 * 由于我们只需要过滤，不需要用户交互，所以这个组件可以为空
 * 但为了保持一致性，我们仍然创建一个组件
 */
export const TeamsNameFilterPicker: React.FC = () => {
  // 这个过滤器是自动应用的，不需要 UI
  // 如果需要显示过滤状态，可以在这里添加
  return null;
};

